/**
 * Rosie — NEMT Dispatch Platform
 * Copyright (c) 2025-2026 Commonwealth Transport LLC. All rights reserved.
 * PROPRIETARY AND CONFIDENTIAL. Unauthorized use, copying, or distribution is prohibited.
 */
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Today from './pages/Today';
import Drivers from './pages/Drivers';
import Payroll from './pages/Payroll';
import Requests from './pages/Requests';
import Vehicles from './pages/Vehicles';
import Schedule from './pages/Schedule';
import LghChat from './pages/LghChat';
import Estimate from './pages/Estimate';
import Billing from './pages/Billing';
import PersonnelFiles from './pages/PersonnelFiles';
import SheetsCompare from './pages/SheetsCompare';
import Patients from './pages/Patients';
import Training from './pages/Training';
import AskRosie from './pages/AskRosie';
import Rooms from './pages/Rooms';
import Issues from './pages/Issues';
import PaulaConsole from './pages/PaulaConsole';
import MyHours from './pages/MyHours';
import Coverage from './pages/Coverage';
import CheckIns from './pages/CheckIns';
import BusinessRules from './pages/BusinessRules';
import LghRoom from './pages/LghRoom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('nemt_token');
  return token ? children : <Navigate to="/login" />;
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* PB-2: LGH iPad kiosk. Public route (device-token gated, not the
            admin login). Must stay OUTSIDE the PrivateRoute shell. */}
        <Route path="/lgh-room" element={<LghRoom />} />
        <Route path="/" element={
          <PrivateRoute><Dashboard /></PrivateRoute>
        }>
          <Route index element={<Today />} />
          <Route path="schedule" element={<Schedule />} />
          <Route path="drivers" element={<Drivers />} />
          <Route path="requests" element={<Requests />} />
          <Route path="coverage" element={<Coverage />} />
          <Route path="checkins" element={<CheckIns />} />
          <Route path="vehicles" element={<Vehicles />} />
          <Route path="payroll" element={<Payroll />} />
          <Route path="lgh-chat" element={<LghChat />} />
          <Route path="estimate" element={<Estimate />} />
          <Route path="billing" element={<Billing />} />
          <Route path="personnel" element={<PersonnelFiles />} />
          <Route path="sheets-compare" element={<SheetsCompare />} />
          <Route path="patients" element={<Patients />} />
          <Route path="training" element={<Training />} />
          <Route path="ask-rosie" element={<AskRosie />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="issues" element={<Issues />} />
          <Route path="console" element={<PaulaConsole />} />
          <Route path="my-hours" element={<MyHours />} />
          <Route path="business-rules" element={<BusinessRules />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}